import { useEffect, useState } from "react";

import useDataBean from "../../../core/services/dataBean/useDataBean";
import { CashReimbursementServices } from "../cellEditor/CashDesk/CashReimbursement/CashReimbursement-service";
import { toast } from "react-toastify";
import { Singleton } from "../../../core/services/Singleton";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicTable, MASK_DATE, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { BasicPage } from "../../theme/Component/BasicPage";
import { Modal } from "../../theme/Component/Modal";
import { SelectAccountantTree } from "../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { PrintJson } from "../../theme/Component/PrintJson";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { _AccountantConcept, _FiscalResponsability, _FiscalResponsabilityType } from "../../../core/services/dataBean/EntityCatalog";
import { InputDate } from "../../theme/Input/InputDate";
import { BasicSwitch } from "../../theme/Component/BasicSwitch";
import { AccountEditor } from "../../editor/AccountEditor";
import { _MeasurementUnitCode } from "../../../core/services/dataBean/EntityCatalogVdos";




export const MeasurementUnitCode = () => {

    const MeasurementUnitCode = useDataBean(_MeasurementUnitCode);

    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [filtro, setFiltro] = useState(''); // Filtro para la búsqueda
    const service = new CashReimbursementServices();
    const [original, setOriginal] = useState<any>([]);
    const [filteredLista, setFilteredLista] = useState(lista); // Lista filtrada
    const [listadocs, setlistadocs] = useState([]);
    const [search, setSearch] = useState("");
    const [IdAcoount, setIdAcoount] = useState<number>(null)
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });



    useEffect(() => {
        getLista()

    }, [])


    useEffect(() => {
        if (search === "") {
            setFilteredLista(lista);  // Si no hay filtro, mostramos la lista original completa
        } else {
            const filtered = lista.filter(item =>
                item.DataBeanProperties.Name.toLowerCase().includes(search) ||  // Filtrar por el nombre
                item.DataBeanProperties.Description.toLowerCase().includes(search)  // Filtrar por la descripción
            );
            setFilteredLista(filtered);  // Actualizamos la lista filtrada
        }
    }, [lista, search]);  // Este efecto se ejecuta cuando cambian 'lista' o 'search'


    const getLista = () => {

        MeasurementUnitCode.instance.getMeasurementUnitCode(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)

                   //console.log(resp)
                    toast.success('Completado')
                } else {
                    toast.error('NO hay datos')
                }

            }
        )

    }

    const handleSearchChange = (e) => {
        const searchValue = e.target.value.toLowerCase();  // Convertimos el valor de búsqueda a minúsculas para hacer una búsqueda case-insensitive
        setSearch(searchValue);

        if (searchValue === "") {
            setFilteredLista(lista);  // Si no hay búsqueda, mostramos la lista completa
        } else {
            const filtered = lista.filter(item =>
                item.DataBeanProperties.Name.toLowerCase().includes(searchValue) ||  // Filtramos por el nombre
                item.DataBeanProperties.Description.toLowerCase().includes(searchValue)  // Filtramos por la descripción
            );
            setFilteredLista(filtered);  // Actualizamos la lista filtrada
        }
    };


    const create = () => {
        MeasurementUnitCode.setBean({


        });

        setModal({ ...modal, "view": true });
    }


    const deleteItem = () => {
        MeasurementUnitCode.deleteItemVoid(MeasurementUnitCode.bean.IDMeasurementUnitCode).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }


    const editaItem = () => {
       //console.log(MeasurementUnitCode.bean);
        MeasurementUnitCode.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }


    // const editaItem = () => {
    //     MeasurementUnitCode.instance.updateMeasurementUnitCode(MeasurementUnitCode.bean.IDMeasurementUnitCode).then(
    //         (resp: any) => {
    //             getLista();
    //             setModal({ ...modal, "view": false });
    //         }
    //     ).catch(err => {
    //         toast.error(err);
    //     })

    // }

    const head = [
        { title: 'ID', property: 'IDMeasurementUnitCode', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre', property: 'Name', visible: true },

        { title: 'Descripción', property: 'Description', visible: true }


    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }



    return (
        <BasicPage titulo="Tipos de Unidades de Medida">
            <div className="row">
                <div className="col-md-6">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Buscar por nombre o descripción..."
                        value={search}
                        onChange={handleSearchChange} // Actualizamos el filtro
                    />
                </div>
                <div className="col-md-12">
                    <BasicTable body={filteredLista} head={head} rowSet={MeasurementUnitCode.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    {/* <BasicTable body={lista} head={head} rowSet={MeasurementUnitCode.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable> */}
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <>
                            <div className="row">

                                <div className="col-md-12">
                                    <label>Nombre</label>
                                    <input type="text" name="Name" className="form-control" value={MeasurementUnitCode.bean.Name} onChange={MeasurementUnitCode.handleChange} />

                                </div>

                                <div className="col-md-12">
                                    <label>Descripción</label>
                                    <textarea name="Description" className="form-control" value={MeasurementUnitCode.bean.Description} onChange={MeasurementUnitCode.handleChange} />
                                </div>
                            </div>

                        </>
                    </Modal>

                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}